import React, { useLayoutEffect, useRef } from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function ChapterHead({ data, index }) {
  const { head, copy } = data;
  const containerRef = useRef();
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.animation = 'fade-up 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.3] }
    );

    observer.observe(containerRef.current);
  }, []);
  return (
    <div className={`chapters__head chapters__head--${index}`} ref={containerRef}>
      <h3>{head[index]}</h3>
      <p>
        {copy[index].map((p, i) => {
          return (
            <span className="chapters__head__p" key={'chaterhead' + i}>
              {typeof p === 'string' ? p : <Hyperlink hyperlinkData={p} />}
            </span>
          );
        })}
      </p>
    </div>
  );
}

export default ChapterHead;
